// TIP-518 — Membership / credibility section.
// Centrepiece: a Verified Member badge built from the TREVEX gem motif,
// surrounded by four Member-benefit chips. CTA routes to the public
import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "./Icon";
import gemIcon from "../../../../assets/images/trevex_icon_color.png";

const MembershipGraphic = () => (
  <div className="membership-graphic" aria-hidden="true">
    <div className="mg-glow" />

    <div className="mg-badge">
      <img className="mg-gem" src={gemIcon} alt="" />
      <span className="mg-ring" />
      <span className="mg-verified-pill">
        <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
          <circle cx="6" cy="6" r="5.5" fill="var(--success)" />
          <path d="M3.5 6L5 7.5L8.5 4" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </svg>
        Verified Member
      </span>
    </div>

    <div className="mg-chip mg-chip-tl">
      <div className="mg-chip-dot" style={{ background: "var(--coral)" }} />
      <div>
        <div className="mg-chip-title">Member rate</div>
        <div className="mg-chip-meta">Ten percent off TREVEX products</div>
      </div>
    </div>

    <div className="mg-chip mg-chip-tr">
      <div className="mg-chip-dot" style={{ background: "var(--gold)" }} />
      <div>
        <div className="mg-chip-title">Payment Endorsements</div>
        <div className="mg-chip-meta">Trade reputation, made visible</div>
      </div>
    </div>

    <div className="mg-chip mg-chip-bl">
      <div className="mg-chip-dot" style={{ background: "#3FA9DD" }} />
      <div>
        <div className="mg-chip-title">Partner Program</div>
        <div className="mg-chip-meta">Live credit on the buyers you extend to</div>
      </div>
    </div>

    <div className="mg-chip mg-chip-br">
      <div className="mg-chip-dot" style={{ background: "var(--success)" }} />
      <div>
        <div className="mg-chip-title">Verification</div>
        <div className="mg-chip-meta">Included with Membership</div>
      </div>
    </div>
  </div>
);

const MembershipSection = () => {
  const navigate = useNavigate();
  return (
    <section data-component="MembershipBlock" className="section-dark" id="membership">
      <div className="container-wide">
        <div className="membership-grid">
          <div>
            <div className="sec-eyebrow"><span className="sec-eyebrow-dot" />Credibility</div>
            <h2 className="sec-title-dark">
              Membership opens TREVEX up.{" "}
              <span style={{ color: "var(--gold)", fontWeight: 300 }}>
                Verification raises the standard.
              </span>
            </h2>
            <p className="sec-body-dark">
              Members get the Member rate, Payment Endorsements, the Partner Program, and the option to complete Verification.
            </p>
            <div style={{ marginTop: 32 }}>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => navigate("/membership")}
                style={{ height: 48, padding: "0 22px", fontSize: 14.5 }}
              >
                Become a member <Icon name="arrow-right" size={14} />
              </button>
            </div>
          </div>
          <MembershipGraphic />
        </div>
      </div>
    </section>
  );
};

export default MembershipSection;
